import React, { Component } from 'react';
import host from '../../assets/js/Host';
const urlParams = new URLSearchParams(window.location.search);

let Getid = urlParams.get('id')
class OrdersTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            selectedOrders: [],
            selectAll: false,
            showTransferModal: false,
            transferToName: '',
            employees: [],
            loading: true,
            error: null,
            pagination: {
                currentPage: 1,
                totalPages: 1,
                totalItems: 0,
                itemsPerPage: 1000
            },
            summary: {
                totalOrders: 0,
                rejectedOrders: 0,
                pendingOrders: 0
            },
            currentUserId: Getid, // يمكن تمريره كـ prop أو من context
            apiBaseUrl: host
        };
    }

    componentDidMount() {
        this.fetchOrders();
        this.fetchEmployees();
    }

    // دالة الرجوع للصفحة السابقة
    handleGoBack = () => {
        window.history.back();
    };

    // جلب الطلبات من API
    fetchOrders = async (page = 1) => {
        const { currentUserId, apiBaseUrl, pagination } = this.state;

        this.setState({ loading: true, error: null });

        try {
            const response = await fetch(

                `${apiBaseUrl}users/user/${currentUserId}/pending-rejected?page=${page}&limit=${pagination.itemsPerPage}`
            );

            if (!response.ok) {
                throw new Error(`HTTP Error: ${response.status}`);
            }

            const result = await response.json();

            if (result.success) {
                this.setState({
                    orders: result.data.orders,
                    pagination: result.data.pagination,
                    summary: result.data.summary,
                    loading: false,
                    selectedOrders: [],
                    selectAll: false
                });
            } else {
                throw new Error(result.message || 'فشل في جلب البيانات');
            }
        } catch (error) {
            console.error('خطأ في جلب الطلبات:', error);
            this.setState({
                loading: false,
                error: error.message || 'حدث خطأ في الاتصال بالخادم'
            });
        }
    };

    // جلب قائمة الموظفين المتاحين للتخصيص
    fetchEmployees = async () => {
        const { apiBaseUrl, currentUserId } = this.state;

        try {
            const response = await fetch(`${apiBaseUrl}users/available-for-assignment`);

            if (response.ok) {
                const result = await response.json();

                if (result.success && result.data && Array.isArray(result.data.users)) {
                    // إهمال المستخدم الحالي من القائمة
                    const availableUsers = result.data.users.filter(user => user.id !== currentUserId);

                    this.setState({
                        employees: availableUsers.map(user => ({
                            id: user.id,
                            name: user.name,
                            phone: user.phone,
                            countOrders: user.countOrders,
                            isOnline: user.isOnline,
                            lastAssignedAt: user.lastAssignedAt,
                            workingHours: user.workingHours,
                            displayName: user.name
                        }))
                    });
                }
            }
        } catch (error) {
            console.error('خطأ في جلب قائمة الموظفين المتاحين:', error);
            // استخدام قائمة افتراضية في حالة الخطأ (مع إهمال المستخدم الحالي)
            const defaultEmployees = [
                { id: 2, name: 'فاطمة علي', phone: '07802345678', countOrders: 15, isOnline: true },
                { id: 3, name: 'محمد حسن', phone: '07703456789', countOrders: 8, isOnline: false },
                { id: 4, name: 'سارة أحمد', phone: '07604567890', countOrders: 22, isOnline: true },
                { id: 5, name: 'علي حسين', phone: '07505678901', countOrders: 5, isOnline: true }
            ].filter(emp => emp.id !== currentUserId);

            this.setState({
                employees: defaultEmployees.map(user => ({
                    ...user,
                    displayName: user.name
                }))
            });
        }
    };

    // تحويل الطلبات لموظف آخر
    transferOrders = async (newUserId) => {
        const { selectedOrders, apiBaseUrl } = this.state;

        try {
            const response = await fetch(`${apiBaseUrl}users/transfer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    orderIds: selectedOrders,
                    newUserId: newUserId
                })
            });

            const result = await response.json();

            // إرجاع النتيجة مباشرة (سواء نجحت أم لا)
            return result;

        } catch (error) {
            console.error('خطأ في تحويل الطلبات:', error);
            return {
                success: false,
                message: 'حدث خطأ في الاتصال بالخادم'
            };
        }
    };

    handleSelectAll = () => {
        const { selectAll, orders } = this.state;
        if (selectAll) {
            this.setState({
                selectedOrders: [],
                selectAll: false
            });
        } else {
            this.setState({
                selectedOrders: orders.map(order => order.id),
                selectAll: true
            });
        }
    };

    handleSelectOrder = (orderId) => {
        const { selectedOrders } = this.state;
        let newSelectedOrders;

        if (selectedOrders.includes(orderId)) {
            newSelectedOrders = selectedOrders.filter(id => id !== orderId);
        } else {
            newSelectedOrders = [...selectedOrders, orderId];
        }

        this.setState({
            selectedOrders: newSelectedOrders,
            selectAll: newSelectedOrders.length === this.state.orders.length
        });
    };

    handleTransferOrders = () => {
        this.setState({ showTransferModal: true });
    };

    handleCloseModal = () => {
        this.setState({
            showTransferModal: false,
            transferToName: ''
        });
    };

    handleConfirmTransfer = async () => {
        const { selectedOrders, transferToName } = this.state;

        if (!transferToName.trim()) {
            alert('يرجى اختيار الموظف المراد التحويل إليه');
            return;
        }

        // إضافة حالة التحميل
        this.setState({ loading: true });

        try {
            const selectedEmployee = this.state.employees.find(emp => emp.displayName === transferToName);
            if (!selectedEmployee) {
                alert('الموظف المحدد غير موجود');
                return;
            }

            const result = await this.transferOrders(selectedEmployee.id);

            if (result.success) {
                this.setState({
                    showTransferModal: false,
                    transferToName: ''
                });

                alert(`${result.message}`);

                // إعادة تحميل البيانات والموظفين
                await Promise.all([
                    this.fetchOrders(this.state.pagination.currentPage),
                    this.fetchEmployees()
                ]);
            } else {
                alert(`فشل التحويل: ${result.message}`);
            }
        } catch (error) {
            alert('حدث خطأ في تحويل الطلبات: ' + error.message);
        } finally {
            this.setState({ loading: false });
        }
    };

    handlePageChange = (newPage) => {
        this.fetchOrders(newPage);
    };

    getStatusColor = (status) => {
        switch (status) {
            case -1:
                return 'bg-yellow-100 text-yellow-800 border-yellow-200';
            case -2:
                return 'bg-red-100 text-red-800 border-red-200';
            case -3: // حالة لا يرد
                return 'bg-orange-100 text-orange-800 border-orange-200';
            default:
                return 'bg-gray-100 text-gray-800 border-gray-200';
        }
    };

    // دالة لإظهار حالة الطلب مع عدد المحاولات
    renderOrderStatus = (order) => {
        const baseStatusStyle = {
            padding: '0.5rem 1rem',
            borderRadius: '25px',
            fontSize: '0.8rem',
            fontWeight: '500',
            border: '1px solid',
            display: 'inline-block',
            minWidth: '80px'
        };

        // إذا كانت الحالة "لا يرد" (status === -3 أو statusText يحتوي على "لا يرد")
        if (order.status === -3 || (order.statusText && order.statusText.includes('لا يرد'))) {
            return (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{
                        ...baseStatusStyle,
                        background: 'linear-gradient(135deg, #fed7aa, #fb923c)',
                        color: '#ea580c',
                        border: '1px solid #fdba74',
                        fontWeight: '600'
                    }}>
                        {order.statusText || 'لا يرد'}
                    </span>
                    {order.miss_count !== undefined && (
                        <span style={{
                            background: order.miss_count > 0 
                                ? 'linear-gradient(135deg, #ef4444, #dc2626)' // أحمر للمحاولات أكثر من 0
                                : 'linear-gradient(135deg, #6b7280, #4b5563)', // رمادي للمحاولات = 0
                            color: 'white',
                            padding: '0.25rem 0.6rem',
                            borderRadius: '15px',
                            fontSize: '0.7rem',
                            fontWeight: '600',
                            boxShadow: order.miss_count > 0 
                                ? '0 2px 8px rgba(239, 68, 68, 0.3)' // ظل أحمر
                                : '0 2px 8px rgba(107, 114, 128, 0.3)', // ظل رمادي
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem'
                        }}>
                            <span style={{ fontSize: '0.6rem' }}>📞</span>
                            {order.miss_count} محاولة
                        </span>
                    )}
                </div>
            );
        }

        // للحالات العادية الأخرى
        return (
            <span style={{
                ...baseStatusStyle
            }}
                className={this.getStatusColor(order.status)}>
                {order.statusText}
            </span>
        );
    };

    formatPrice = (price) => {
        return new Intl.NumberFormat('ar-IQ', {
            style: 'currency',
            currency: 'IQD',
            minimumFractionDigits: 0
        }).format(price);
    };

    formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('ar-IQ');
    };

    render() {
        const {
            orders,
            selectedOrders,
            selectAll,
            showTransferModal,
            transferToName,
            employees,
            loading,
            error,
            pagination,
            summary
        } = this.state;

        if (loading) {
            return (
                <div dir="rtl" style={{
                    minHeight: '100vh',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif'
                }}>
                    <div style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        padding: '3rem',
                        borderRadius: '20px',
                        textAlign: 'center',
                        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.1)'
                    }}>
                        <div style={{
                            width: '60px',
                            height: '60px',
                            border: '4px solid #f3f3f3',
                            borderTop: '4px solid #3b82f6',
                            borderRadius: '50%',
                            animation: 'spin 1s linear infinite',
                            margin: '0 auto 1rem'
                        }}></div>
                        <h3 style={{ margin: '0', color: '#374151' }}>جاري تحميل الطلبات...</h3>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div dir="rtl" style={{
                    minHeight: '100vh',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif'
                }}>
                    <div style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        padding: '3rem',
                        borderRadius: '20px',
                        textAlign: 'center',
                        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.1)',
                        maxWidth: '500px'
                    }}>
                        <div style={{
                            fontSize: '3rem',
                            color: '#ef4444',
                            marginBottom: '1rem'
                        }}>⚠️</div>
                        <h3 style={{ margin: '0 0 1rem 0', color: '#374151' }}>خطأ في تحميل البيانات</h3>
                        <p style={{ margin: '0 0 2rem 0', color: '#6b7280' }}>{error}</p>
                        <button
                            onClick={() => this.fetchOrders()}
                            style={{
                                background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                                color: 'white',
                                border: 'none',
                                padding: '0.75rem 2rem',
                                borderRadius: '25px',
                                cursor: 'pointer',
                                fontSize: '1rem',
                                fontWeight: '500'
                            }}
                        >
                            إعادة المحاولة
                        </button>
                    </div>
                </div>
            );
        }

        return (
            <div dir="rtl" style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '2rem',
                fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif'
            }}>
                <style>
                    {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
                </style>

                <div style={{
                    maxWidth: '1400px',
                    margin: '0 auto',
                    position: 'relative'
                }}>
                    {/* Back Button */}
                    <button
                        onClick={this.handleGoBack}
                        style={{
                            position: 'absolute',
                            top: '0',
                            left: '0',
                            background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                            border: 'none',
                            borderRadius: '15px',
                            padding: '0.75rem 1.5rem',
                            cursor: 'pointer',
                            fontSize: '1rem',
                            fontWeight: '600',
                            color: 'white',
                            boxShadow: '0 10px 25px rgba(59, 130, 246, 0.4)',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            zIndex: 10
                        }}
                        onMouseEnter={(e) => {
                            e.target.style.transform = 'translateY(-2px)';
                            e.target.style.boxShadow = '0 15px 35px rgba(59, 130, 246, 0.5)';
                            e.target.style.background = 'linear-gradient(135deg, #2563eb, #1e40af)';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 10px 25px rgba(59, 130, 246, 0.4)';
                            e.target.style.background = 'linear-gradient(135deg, #3b82f6, #1d4ed8)';
                        }}
                    >
                        <span style={{ fontSize: '1.2rem' }}>←</span>
                        رجوع
                    </button>

                    {/* Header */}
                    <div style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        backdropFilter: 'blur(20px)',
                        borderRadius: '20px',
                        padding: '2rem',
                        marginBottom: '2rem',
                        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.1)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        marginTop: '4rem' // إضافة مسافة من الأعلى لتجنب تداخل الزر
                    }}>
                        <h1 style={{
                            fontSize: '2.5rem',
                            fontWeight: '700',
                            background: 'linear-gradient(135deg, #667eea, #764ba2)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            textAlign: 'center',
                            margin: '0',
                            marginBottom: '0.5rem'
                        }}>
                            الطلبات المعلقة والمرفوضة
                        </h1>
                        <p style={{
                            textAlign: 'center',
                            color: '#6b7280',
                            fontSize: '1.1rem',
                            margin: '0'
                        }}>
                            عرض وإدارة الطلبات التي تحتاج إلى متابعة
                        </p>
                    </div>

                    {/* Stats Cards */}
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                        gap: '1.5rem',
                        marginBottom: '2rem'
                    }}>
                        <div style={{
                            background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                            borderRadius: '16px',
                            padding: '1.5rem',
                            color: 'white',
                            boxShadow: '0 10px 25px rgba(245, 158, 11, 0.3)'
                        }}>
                            <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1rem', opacity: 0.9 }}>إجمالي الطلبات</h3>
                            <p style={{ margin: '0', fontSize: '2rem', fontWeight: 'bold' }}>{summary.totalOrders}</p>
                        </div>
                        <div style={{
                            background: 'linear-gradient(135deg, #eab308, #ca8a04)',
                            borderRadius: '16px',
                            padding: '1.5rem',
                            color: 'white',
                            boxShadow: '0 10px 25px rgba(234, 179, 8, 0.3)'
                        }}>
                            <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1rem', opacity: 0.9 }}>الطلبات المعلقة</h3>
                            <p style={{ margin: '0', fontSize: '2rem', fontWeight: 'bold' }}>{summary.pendingOrders}</p>
                        </div>
                        <div style={{
                            background: 'linear-gradient(135deg, #ef4444, #dc2626)',
                            borderRadius: '16px',
                            padding: '1.5rem',
                            color: 'white',
                            boxShadow: '0 10px 25px rgba(239, 68, 68, 0.3)'
                        }}>
                            <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1rem', opacity: 0.9 }}>الطلبات المرفوضة</h3>
                            <p style={{ margin: '0', fontSize: '2rem', fontWeight: 'bold' }}>{summary.rejectedOrders}</p>
                        </div>
                        <div style={{
                            background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                            borderRadius: '16px',
                            padding: '1.5rem',
                            color: 'white',
                            boxShadow: '0 10px 25px rgba(59, 130, 246, 0.3)'
                        }}>
                            <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1rem', opacity: 0.9 }}>الطلبات المحددة</h3>
                            <p style={{ margin: '0', fontSize: '2rem', fontWeight: 'bold' }}>{selectedOrders.length}</p>
                        </div>
                    </div>

                    {/* Table Container */}
                    <div style={{
                        background: 'rgba(255, 255, 255, 0.95)',
                        backdropFilter: 'blur(20px)',
                        borderRadius: '20px',
                        overflow: 'hidden',
                        boxShadow: '0 25px 50px rgba(0, 0, 0, 0.1)',
                        border: '1px solid rgba(255, 255, 255, 0.2)'
                    }}>
                        {/* Table Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #1f2937, #374151)',
                            padding: '1.5rem',
                            color: 'white'
                        }}>
                            <div style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <h2 style={{
                                    margin: '0',
                                    fontSize: '1.5rem',
                                    fontWeight: '600'
                                }}>
                                    قائمة الطلبات ({pagination.totalItems})
                                </h2>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '1rem'
                                }}>
                                    <label style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '0.5rem',
                                        cursor: 'pointer',
                                        fontSize: '0.9rem'
                                    }}>
                                        <input
                                            type="checkbox"
                                            checked={selectAll}
                                            onChange={this.handleSelectAll}
                                            style={{
                                                width: '18px',
                                                height: '18px',
                                                accentColor: '#3b82f6'
                                            }}
                                        />
                                        تحديد الكل
                                    </label>
                                    {selectedOrders.length > 0 && (
                                        <span style={{
                                            background: 'rgba(59, 130, 246, 0.2)',
                                            padding: '0.5rem 1rem',
                                            borderRadius: '25px',
                                            fontSize: '0.9rem',
                                            border: '1px solid rgba(59, 130, 246, 0.3)'
                                        }}>
                                            {selectedOrders.length} محدد
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>

                        {/* Table */}
                        {orders.length === 0 ? (
                            <div style={{
                                padding: '4rem',
                                textAlign: 'center',
                                color: '#6b7280'
                            }}>
                                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>📋</div>
                                <h3 style={{ margin: '0 0 0.5rem 0' }}>لا توجد طلبات</h3>
                                <p style={{ margin: '0' }}>لا يوجد طلبات معلقة أو مرفوضة حالياً</p>
                            </div>
                        ) : (
                            <div style={{ overflowX: 'auto' }}>
                                <table style={{
                                    width: '100%',
                                    borderCollapse: 'collapse'
                                }}>
                                    <thead>
                                        <tr style={{
                                            background: 'linear-gradient(135deg, #f8fafc, #e2e8f0)',
                                            borderBottom: '2px solid #e2e8f0'
                                        }}>
                                            <th style={{
                                                padding: '1rem',
                                                textAlign: 'center',
                                                fontWeight: '600',
                                                color: '#374151',
                                                fontSize: '0.9rem'
                                            }}>تحديد</th>
                                            <th style={{
                                                padding: '1rem',
                                                textAlign: 'right',
                                                fontWeight: '600',
                                                color: '#374151',
                                                fontSize: '0.9rem'
                                            }}>رقم الطلب</th>
                                            <th style={{
                                                padding: '1rem',
                                                textAlign: 'center',
                                                fontWeight: '600',
                                                color: '#374151',
                                                fontSize: '0.9rem'
                                            }}>اسم العميل</th>
                                            <th style={{
                                                padding: '1rem',
                                                textAlign: 'center',
                                                fontWeight: '600',
                                                color: '#374151',
                                                fontSize: '0.9rem'
                                            }}>حالة الطلب</th>
                                            <th style={{
                                                padding: '1rem',
                                                textAlign: 'center',
                                                fontWeight: '600',
                                                color: '#374151',
                                                fontSize: '0.9rem'
                                            }}>تاريخ الطلب</th>
                                            <th style={{
                                                padding: '1rem',
                                                textAlign: 'center',
                                                fontWeight: '600',
                                                color: '#374151',
                                                fontSize: '0.9rem'
                                            }}>المحافظة</th>
                                            <th style={{
                                                padding: '1rem',
                                                textAlign: 'center',
                                                fontWeight: '600',
                                                color: '#374151',
                                                fontSize: '0.9rem'
                                            }}>السعر الإجمالي</th>
                                            <th style={{
                                                padding: '1rem',
                                                textAlign: 'center',
                                                fontWeight: '600',
                                                color: '#374151',
                                                fontSize: '0.9rem'
                                            }}>المادة</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {orders.map((order, index) => (
                                            <tr
                                                key={order.id}
                                                style={{
                                                    background: selectedOrders.includes(order.id)
                                                        ? 'rgba(59, 130, 246, 0.05)'
                                                        : index % 2 === 0 ? '#ffffff' : '#f8fafc',
                                                    borderBottom: '1px solid #e2e8f0',
                                                    transition: 'all 0.3s ease',
                                                    cursor: 'pointer'
                                                }}
                                                onMouseEnter={(e) => {
                                                    if (!selectedOrders.includes(order.id)) {
                                                        e.currentTarget.style.background = '#f1f5f9';
                                                    }
                                                }}
                                                onMouseLeave={(e) => {
                                                    if (!selectedOrders.includes(order.id)) {
                                                        e.currentTarget.style.background = index % 2 === 0 ? '#ffffff' : '#f8fafc';
                                                    }
                                                }}
                                            >
                                                <td style={{
                                                    padding: '1rem',
                                                    textAlign: 'center'
                                                }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedOrders.includes(order.id)}
                                                        onChange={() => this.handleSelectOrder(order.id)}
                                                        style={{
                                                            width: '18px',
                                                            height: '18px',
                                                            accentColor: '#3b82f6'
                                                        }}
                                                    />
                                                </td>
                                                <td style={{
                                                    padding: '1rem',
                                                    textAlign: 'right',
                                                    fontWeight: '600',
                                                    color: '#1f2937'
                                                }}>
                                                    {order.orderNumber}
                                                </td>
                                                <td style={{
                                                    padding: '1rem',
                                                    textAlign: 'center',
                                                    fontWeight: '500',
                                                    color: '#374151'
                                                }}>
                                                    {order.customerName}
                                                </td>
                                                <td style={{
                                                    padding: '1rem',
                                                    textAlign: 'center'
                                                }}>
                                                    {this.renderOrderStatus(order)}
                                                </td>
                                                <td style={{
                                                    padding: '1rem',
                                                    textAlign: 'center',
                                                    color: '#6b7280'
                                                }}>
                                                    {this.formatDate(order.createdAt)}
                                                </td>
                                                <td style={{
                                                    padding: '1rem',
                                                    textAlign: 'center',
                                                    fontWeight: '500',
                                                    color: '#374151'
                                                }}>
                                                    {order.government}
                                                </td>
                                                <td style={{
                                                    padding: '1rem',
                                                    textAlign: 'center',
                                                    fontWeight: '600',
                                                    color: '#059669'
                                                }}>
                                                    {this.formatPrice(order.totalPrice)}
                                                </td>
                                                <td style={{
                                                    padding: '1rem',
                                                    textAlign: 'center',
                                                    color: '#374151'
                                                }}>
                                                    <span style={{
                                                        background: 'linear-gradient(135deg, #fef3c7, #fde68a)',
                                                        padding: '0.25rem 0.75rem',
                                                        borderRadius: '15px',
                                                        fontSize: '0.8rem',
                                                        fontWeight: '500',
                                                        color: '#92400e'
                                                    }}>
                                                        {order.notes2}
                                                    </span>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        )}

                        {/* Pagination */}
                        {pagination.totalPages > 1 && (
                            <div style={{
                                background: 'linear-gradient(135deg, #f8fafc, #e2e8f0)',
                                padding: '1rem 1.5rem',
                                borderTop: '1px solid #e2e8f0',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '0.5rem'
                            }}>
                                <button
                                    onClick={() => this.handlePageChange(pagination.currentPage - 1)}
                                    disabled={!pagination.hasPrevPage}
                                    style={{
                                        background: pagination.hasPrevPage ? '#3b82f6' : '#d1d5db',
                                        color: 'white',
                                        border: 'none',
                                        padding: '0.5rem 1rem',
                                        borderRadius: '5px',
                                        cursor: pagination.hasPrevPage ? 'pointer' : 'not-allowed',
                                        fontSize: '0.9rem'
                                    }}
                                >
                                    السابق
                                </button>

                                <span style={{
                                    margin: '0 1rem',
                                    color: '#374151',
                                    fontWeight: '500'
                                }}>
                                    صفحة {pagination.currentPage} من {pagination.totalPages}
                                </span>

                                <button
                                    onClick={() => this.handlePageChange(pagination.currentPage + 1)}
                                    disabled={!pagination.hasNextPage}
                                    style={{
                                        background: pagination.hasNextPage ? '#3b82f6' : '#d1d5db',
                                        color: 'white',
                                        border: 'none',
                                        padding: '0.5rem 1rem',
                                        borderRadius: '5px',
                                        cursor: pagination.hasNextPage ? 'pointer' : 'not-allowed',
                                        fontSize: '0.9rem'
                                    }}
                                >
                                    التالي
                                </button>
                            </div>
                        )}

                        {/* Footer Actions */}
                        {selectedOrders.length > 0 && (
                            <div style={{
                                background: 'linear-gradient(135deg, #f8fafc, #e2e8f0)',
                                padding: '1rem 1.5rem',
                                borderTop: '1px solid #e2e8f0',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center'
                            }}>
                                <span style={{
                                    color: '#374151',
                                    fontWeight: '500'
                                }}>
                                    تم تحديد {selectedOrders.length} من أصل {pagination.totalItems} طلبات
                                </span>
                                <div style={{ display: 'flex', gap: '1rem' }}>
                                    <button
                                        onClick={this.handleTransferOrders}
                                        style={{
                                            background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                                            color: 'white',
                                            border: 'none',
                                            padding: '0.5rem 1.5rem',
                                            borderRadius: '25px',
                                            cursor: 'pointer',
                                            fontSize: '0.9rem',
                                            fontWeight: '500',
                                            transition: 'all 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => e.target.style.transform = 'translateY(-2px)'}
                                        onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                                    >
                                        تحويل الطلبات
                                    </button>

                                </div>
                            </div>
                        )}
                    </div>

                    {/* Transfer Modal */}
                    {showTransferModal && (
                        <div style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            zIndex: 1000
                        }}>
                            <div style={{
                                background: 'white',
                                borderRadius: '20px',
                                padding: '2rem',
                                maxWidth: '500px',
                                width: '90%',
                                boxShadow: '0 25px 50px rgba(0, 0, 0, 0.25)',
                                direction: 'rtl',
                                opacity: loading ? '0.7' : '1',
                                pointerEvents: loading ? 'none' : 'auto'
                            }}>
                                <h3 style={{
                                    margin: '0 0 1.5rem 0',
                                    fontSize: '1.5rem',
                                    fontWeight: '600',
                                    color: '#1f2937',
                                    textAlign: 'center'
                                }}>
                                    تحويل الطلبات
                                </h3>

                                <p style={{
                                    margin: '0 0 1.5rem 0',
                                    color: '#6b7280',
                                    textAlign: 'center'
                                }}>
                                    سيتم تحويل {selectedOrders.length} طلب إلى الموظف المحدد
                                </p>

                                <div style={{ marginBottom: '1.5rem' }}>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '0.5rem',
                                        fontWeight: '500',
                                        color: '#374151'
                                    }}>
                                        اختر الموظف:
                                    </label>
                                    <select
                                        value={transferToName}
                                        onChange={(e) => this.setState({ transferToName: e.target.value })}
                                        disabled={loading}
                                        style={{
                                            width: '100%',
                                            padding: '0.75rem',
                                            borderRadius: '10px',
                                            border: '2px solid #e5e7eb',
                                            fontSize: '1rem',
                                            background: loading ? '#f9fafb' : 'white',
                                            color: '#374151',
                                            outline: 'none',
                                            transition: 'border-color 0.3s ease',
                                            cursor: loading ? 'not-allowed' : 'pointer'
                                        }}
                                        onFocus={(e) => !loading && (e.target.style.borderColor = '#3b82f6')}
                                        onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                                    >
                                        <option value="">-- اختر الموظف --</option>
                                        {employees.map((employee) => (
                                            <option key={employee.id} value={employee.displayName}>
                                                {employee.displayName}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                {/* مؤشر التحميل */}
                                {loading && (
                                    <div style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        marginBottom: '1rem'
                                    }}>
                                        <div style={{
                                            width: '30px',
                                            height: '30px',
                                            border: '3px solid #f3f3f3',
                                            borderTop: '3px solid #3b82f6',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite',
                                            marginLeft: '0.5rem'
                                        }}></div>
                                        <span style={{ color: '#6b7280', fontSize: '0.9rem' }}>
                                            جاري تحويل الطلبات...
                                        </span>
                                    </div>
                                )}

                                <div style={{
                                    display: 'flex',
                                    gap: '1rem',
                                    justifyContent: 'center'
                                }}>
                                    <button
                                        onClick={this.handleConfirmTransfer}
                                        disabled={loading || !transferToName}
                                        style={{
                                            background: (!transferToName || loading)
                                                ? 'linear-gradient(135deg, #9ca3af, #6b7280)'
                                                : 'linear-gradient(135deg, #10b981, #059669)',
                                            color: 'white',
                                            border: 'none',
                                            padding: '0.75rem 2rem',
                                            borderRadius: '25px',
                                            cursor: (!transferToName || loading) ? 'not-allowed' : 'pointer',
                                            fontSize: '1rem',
                                            fontWeight: '500',
                                            transition: 'all 0.3s ease',
                                            opacity: (!transferToName || loading) ? '0.6' : '1'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!loading && transferToName) {
                                                e.target.style.transform = 'translateY(-2px)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!loading && transferToName) {
                                                e.target.style.transform = 'translateY(0)';
                                            }
                                        }}
                                    >
                                        {loading ? 'جاري التحويل...' : 'تأكيد التحويل'}
                                    </button>
                                    <button
                                        onClick={this.handleCloseModal}
                                        disabled={loading}
                                        style={{
                                            background: loading
                                                ? 'linear-gradient(135deg, #9ca3af, #6b7280)'
                                                : 'linear-gradient(135deg, #6b7280, #4b5563)',
                                            color: 'white',
                                            border: 'none',
                                            padding: '0.75rem 2rem',
                                            borderRadius: '25px',
                                            cursor: loading ? 'not-allowed' : 'pointer',
                                            fontSize: '1rem',
                                            fontWeight: '500',
                                            transition: 'all 0.3s ease',
                                            opacity: loading ? '0.6' : '1'
                                        }}
                                        onMouseEnter={(e) => {
                                            if (!loading) {
                                                e.target.style.transform = 'translateY(-2px)';
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (!loading) {
                                                e.target.style.transform = 'translateY(0)';
                                            }
                                        }}
                                    >
                                        إلغاء
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default OrdersTable;